<template>
  <div class="bg-white borderd">
    <div class="px-10 py-2 mx-auto mt-0">
      <div class="flex items-center">
        <select class="w-64 form-select" v-model="selectedGrantType">
          <option></option>
          <option value="implicit">implicit</option>
          <option value="hybrid">hybrid</option>
          <option value="authorization_code">authorization_code</option>
          <option value="client_credentials">client_credentials</option>
          <option value="password">password</option>
        </select>
        <button class="bg-transparent focus:outline-none" @click="onAdd">
          <svg fill="currentColor" viewBox="0 0 20 20" class="w-8 h-8 text-blue-500">
            <path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z" clip-rule="evenodd"></path>
          </svg>
        </button>
      </div>
      <table class="mt-5 mb-20 table-fixed w-100">
        <tr class="border-b">
          <td class="w-56 px-4 py-2 text-gray-600 uppercase ">typ</td>
          <td class="px-4 py-2 text-gray-600 uppercase">värde</td>
          <td class="w-20 px-4 py-2" />
        </tr>

        <tbody>
          <tr v-for="g in current.allowedGrantTypes" :key="g" class="bg-white">
            <td class="px-4 py-2 text-gray-900">
              {{g}}
            </td>
            <td class="w-32 px-4 py-2 text-center align-middle">
              <button class="bg-transparent focus:outline-none" @click="onRemove(g)">
                <svg fill="currentColor" viewBox="0 0 20 20" class="w-6 h-6 text-red-500">
                  <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import lodash from "lodash";

export default {
  name: "clientgranttypes",
  data() {
    return {
      selectedGrantType: null
    };
  },

  computed: {
    ...mapGetters("clientsStore", ["current"])
  },

  methods: {
    ...mapActions("clientsStore", ["save", "addGrantType", "removeGrantType"]),
    async onAdd() {
      if (this.selectedGrantType) {
        await this.addGrantType(this.selectedGrantType);
      }
    },
    async onRemove(granttype) {
      await this.removeGrantType(granttype);
    }
  }
};
</script>
